import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/index/logo_textVer.svg")